// extracted by mini-css-extract-plugin
export default {"tabs":"U2-z","tablist":"V2-z","tablistItem":"W2-z"};